import React, { FC } from 'react';
import cn from 'classnames';
import useCartStore from 'src/hooks/useCart';
import useAuthorizationStore from 'src/hooks/useAuthorizationStore';
import { BookingStep } from 'src/page-components/checkout/types';
import useModalStore from 'src/hooks/useModalStore';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import ListIcon from 'src/icons/List';
import Cart from 'src/icons/Cart';
import ListLightIcon from 'src/icons/ListLight';
import useProposalCartStore from 'src/hooks/useProposalCartStore';
import trns from './trns';
import UserIcon from '../../../icons/UserIcon';
import MyPharmacyIcon from '../../../icons/MyPharmacy';
import BookingsIcon from '../../../icons/Bookings';
import ButtonComponent from './ButtonComponent';
import NavigationButton from './NavigationButton';

const navigationOptions = [
  {
    id: 1,
    alt: 'Booking icon',
    href: '/account/bookings',
    title: trns.myBooking,
    icon: BookingsIcon
  },
  {
    id: 3,
    alt: 'Pharmacies icon',
    href: '/account/stores',
    title: trns.myPharmacies,
    icon: MyPharmacyIcon
  }
];

interface UserMenuProps {
  isColumn?: boolean;
  darkStyle?: boolean;
  isHideMenu?: boolean;
  isMobile?: boolean;
  clientInfo?: {
    name: string;
    surname: string;
  };
  gtagPrefix?: GTAGPrefix;
}

const UserMenu: FC<UserMenuProps> = ({
  isColumn = false,
  darkStyle = false,
  isHideMenu = false,
  isMobile = false,
  clientInfo,
  gtagPrefix
}) => {
  const { simpleCartItems } = useCartStore();
  const { userToken } = useAuthorizationStore();
  const { updateModalsConfig } = useModalStore();
  const { pharmacyBookingList } = useProposalCartStore();
  const bookingsList =
    pharmacyBookingList && Object?.values(pharmacyBookingList);

  return (
    <div
      className={cn('flex', {
        'h-full items-end justify-between items-center gap-x-2': !isColumn,
        'flex-col mt-7': isColumn
      })}
    >
      <NavigationButton
        href={`/checkout/cart?step=${BookingStep.ProductList}`}
        shallow
        title={trns.list}
        dataCyName={'list_icon'}
        alt="list icon"
        component={darkStyle ? ListLightIcon : ListIcon}
        width={16}
        height={18}
        badge={`${simpleCartItems?.length || ''}`}
        isFullFormat={isColumn}
        darkStyle={darkStyle}
        gtagPrefix={gtagPrefix}
      />
      <NavigationButton
        href={`/checkout/cart?step=${BookingStep.Cart}`}
        shallow
        title={trns.cart}
        alt="cart icon"
        component={Cart}
        width={16}
        height={18}
        badge={`${bookingsList?.length || ''}`}
        isFullFormat={isColumn}
        darkStyle={darkStyle}
        gtagPrefix={gtagPrefix}
      />
      <div
        className={cn(
          'flex-row justify-between',
          isMobile ? 'flex' : 'hidden lm:flex'
        )}
      >
        <NavigationButton
          onClick={(event) => {
            if (!userToken) {
              // Prevent redirect
              event.preventDefault();
              updateModalsConfig('authorization-modal', true);
            }
          }}
          href="/account/profile"
          title={userToken ? trns.myProfile : trns.signInUp}
          alt="profile icon"
          component={UserIcon}
          width={20}
          height={28}
          isHideIcon={!!userToken}
          isFullFormat={isColumn}
          darkStyle={darkStyle}
          badge={isColumn || userToken ? '' : '!'}
          buttonComponent={
            <ButtonComponent
              isHideMenu={isHideMenu}
              darkStyle={darkStyle}
              userToken={userToken}
              clientInfo={clientInfo}
            />
          }
        />
      </div>
      {userToken && !isHideMenu ? (
        <div>
          {navigationOptions.map((option) => {
            return (
              <NavigationButton
                key={option.id}
                href={option.href}
                title={option.title}
                alt={option.alt}
                component={option.icon}
                width={28}
                height={24}
                isFullFormat={isColumn}
                darkStyle={darkStyle}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default UserMenu;
